// Devuelve 'black' o 'white' según el brillo del color de fondo
export const getContrastingTextColor = (hexColor) => {
    if (!hexColor) return 'white';
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 160 ? 'black' : 'white';
}

// Oscurece el color hexadecimal en un porcentaje
export const darkenColor = (hex, percent = 20) => {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) - amt;
    const G = ((num >> 8) & 0x00FF) - amt;
    const B = (num & 0x0000FF) - amt;
    return (
        '#' +
        (
            0x1000000 +
            (Math.max(R, 0) << 16) +
            (Math.max(G, 0) << 8) +
            Math.max(B, 0)
        )
            .toString(16)
            .slice(1)
    );
}